import React from 'react';
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import {CardContainer, Input, Button, Dialog, Validator, Notification} from 'components/common/uiKit';
import {NoRecord} from 'components/common/app';

import {LessonApi} from 'services/network/api';
import {convertDigitsToStandard} from 'services/converts/numbers';


class SubLesson extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lessonId: props.lessonId,
            data: props.childs,
            showAddDialog: false,
            subLessonName: '',
            createBtnLoading: false
        }

        this.validator = Validator(props.locale.abbreviation);
    }

    handleLink = id => {
        const {history} = this.props;
        history.push({
            pathname: `lesson?lessonId=${id}`,
            //search: `?lessonId=${id}`,
            //state: {...data}
        });
    };

    handleAddOnClick = () => {
        this.setState({showAddDialog: true});
    };


    handleSubmitAddClick = () => {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Lesson.Sub;

        let validationResult = true;
        validationResult = this.validator.fieldValid(pageTranslates.SubLessonName);

        if (validationResult) {
            this.setState({createBtnLoading: true});
            const {subLessonName, lessonId} = this.state;
            const model = {title: subLessonName, parentId: parseInt(lessonId)};

            LessonApi.CreateSub(model)
                .then(res => {
                    if (res.status == 200) {
                        let {data} = this.state;
                        data.push({id: res.data.id, title: subLessonName});
                        Notification('success', 'Succeed');
                        this.setState({showAddDialog: false, data, subLessonName: ''});
                    }
                })
                .finally(x => {
                    this.setState({createBtnLoading: false});
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            Notification('error', 'WrongData');
            this.setState({createBtnLoading: false});
        }
    };

    handleInputChange = name => event => {
        this.setState({[name]: convertDigitsToStandard(event.target.value)});
    };

    render() {
        const {lessonId, data, showAddDialog, subLessonName, createBtnLoading} = this.state;


        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Lesson.Sub;

        return (
            <>
                <div className='m-3'>
                    <Button full type='success' shadowType='sm' onClick={this.handleAddOnClick}>
                        <i className='fa fa-plus font-weight-bold ml-2'/>
                        <span className='font-weight-bold font-14'>
                            {pageTranslates.Create}
                        </span>
                    </Button>
                </div>

                {!data || data.length == 0 ?
                    <NoRecord message='SubLesson'/>
                    :
                    <CardContainer>
                        <div className="list-group list-custom-small">
                            {data.map((item, index) => {
                                const number = index + 1;
                                const {title} = item;
                                return (
                                    <Link onClick={this.handleLink.bind(this, item.id)}>
                                        <i className='rounded-sm shadow-xl bg-primary' style={{fontStyle: 'normal'}}>
                                            {number}
                                        </i>
                                        <span className='float-right'>
                                    {title}
                                </span>
                                        <i className="fa fa-angle-left"></i>
                                    </Link>
                                );
                            })}
                        </div>
                    </CardContainer>
                }

                <Dialog open={showAddDialog} title={pageTranslates.Create}>
                    <div>
                        <div>
                            <label className='mb-0 color-primary'>
                                {pageTranslates.SubLessonName}
                            </label>
                            <Input placeholder={pageTranslates.SubLessonName} value={subLessonName}
                                   onChange={this.handleInputChange('subLessonName')}
                            />
                            {this.validator.message(pageTranslates.SubLessonName, subLessonName, 'required|min:3')}
                        </div>
                        <div>
                            <Button full onClick={this.handleSubmitAddClick} loading={createBtnLoading}>
                                {pageTranslates.CreateDialog.Submit}
                            </Button>
                            <Button full type='secondary' onClick={() => this.setState({showAddDialog: false})}>
                                {pageTranslates.CreateDialog.Cancel}
                            </Button>
                        </div>
                    </div>
                </Dialog>
            </>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(SubLesson));